import { StandardChip } from "../../../../../shared/components/badges/StandardChip"
import { MeetingOrderFilterType } from "../../../../../shared/components/filters/orderTypeFilter/helpers"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { MeetingAudienceChip } from "../../home/components/meetigs/MeetingAudienceChip"

import type { UpcomingMeetingRow } from "../upcomingMeetingsTypes"

type Props = Readonly<{
    meeting: UpcomingMeetingRow
}>

export function UpcomingMeetingTags({ meeting }: Props) {
    return (
        <>
            {meeting.orderKind === MeetingOrderFilterType.MEETING_SERVICE ? (
                <LocalizedStrict id="service-center-reports-upcoming-meetings-row-tag-meeting-service">
                    <StandardChip variant="success" placement="table" size="small">
                        Meeting service
                    </StandardChip>
                </LocalizedStrict>
            ) : (
                meeting.resourceTypes.map((type) => (
                    <LocalizedEnum key={type} base="service-center-reports-upcoming-meetings-row-tag" enumValue={type}>
                        <StandardChip variant="info" placement="table" size="small">
                            {type}
                        </StandardChip>
                    </LocalizedEnum>
                ))
            )}
            <MeetingAudienceChip audience={meeting.audience} />
        </>
    )
}
